import React from 'react';
import EntityManagementScreen from '../common/EntityManagementScreen';
import { UserOutlined } from '@ant-design/icons';

const ApplicationUserManagementScreen = () => {
  return (
    <EntityManagementScreen 
      entityName="ApplicationUser" 
      beautifulName="ApplicationUser"
      icon={<UserOutlined style={{ fontSize: 24 }} />}
    />
  );
};

export default ApplicationUserManagementScreen; 